import React, { ReactElement } from 'react';
import { Route, Routes } from 'react-router-dom';
import routepaths from './routepaths';
import Authenticate from '../components/Auth/Authenticate';
import Login from '../pages/Login';
import Base from '../components/Base';
import Logout from '../pages/Logout';
import Layout from '../layout';
import GenesisRoutes from './GenesisRoutes';
import IAppRoute from './AppRoute.type';
import RequireAuth from '../components/Auth/RequireAuth';
import ErrorComp from '../pages/Error';
import Forbidden from '../pages/Forbidden';

const allRoutes: IAppRoute[] = [...GenesisRoutes];

function AppRouter(): ReactElement {
  return (
    <Routes>
      <Route path={routepaths.login} element={<Login />} />
      <Route path={routepaths.base} element={<Base />} />
      <Route path={routepaths.authenticate} element={<Authenticate />} />
      <Route path={routepaths.logout} element={<Logout messageKey='M1' />} />
      <Route
        path={routepaths.unauthorized}
        element={<Logout messageKey='M2' />}
      />
      <Route
        path={routepaths.blockedAddress}
        element={<Logout messageKey='M3' />}
      />
      <Route path={routepaths.authError} element={<Logout messageKey='M4' />} />
      <Route
        path={routepaths.forbiddenAccess}
        element={<Logout messageKey='M5' />}
      />
      <Route
        path={routepaths.notAuthorized}
        element={<Logout messageKey='M6' />}
      />

      <Route path='*' element={<span>404</span>} />

      <Route element={<RequireAuth />}>
        <Route element={<Layout />}>
          {allRoutes.map(({ path, element }) => (
            <Route key={`route_${path}`} path={path} element={element} />
          ))}
          <Route path={routepaths.error} element={<ErrorComp />} />
        </Route>
        <Route path={routepaths.forbidden} element={<Forbidden />} />
      </Route>
    </Routes>
  );
}

export default AppRouter;
